import { render, staticRenderFns } from "./Navbar3.vue?vue&type=template&id=846c4496"
import script from "./Navbar3.vue?vue&type=script&lang=js"
export * from "./Navbar3.vue?vue&type=script&lang=js"
import style0 from "./Navbar3.vue?vue&type=style&index=0&id=846c4496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports